import React, { useState, useEffect, useContext } from 'react';
import { Button, Input, VStack, Text, Box, useToast } from '@chakra-ui/react';
import { UserContext } from './UserContext';
import UserSettingsLayout from './UserSettingsLayout';


const Profile = () => {
  const { userDetails, setUserDetails } = useContext(UserContext);
  const [firstName, setFirstName] = useState(userDetails?.first_name || '');
  const [lastName, setLastName] = useState(userDetails?.last_name || '');
  const [location, setLocation] = useState(userDetails?.location || '');
  const [profession, setProfession] = useState(userDetails?.profession || '');
  const [bio, setBio] = useState(userDetails?.bio || '');
  const toast = useToast();

  useEffect(() => {
    if (userDetails) {
      setFirstName(userDetails.first_name || '');
      setLastName(userDetails.last_name || '');
      setLocation(userDetails.location || '');
      setProfession(userDetails.profession || '');
      setBio(userDetails.bio || '');
    }
  }, [userDetails]);

  const handleSave = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast({
        title: 'Error',
        description: 'Please log in to update your profile.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await fetch('/api/user/details', {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          first_name: firstName,
          last_name: lastName,
          location,
          profession,
          bio,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast({
          title: 'Profile Updated',
          description: 'Your profile information has been updated successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        // Update context with the new data
        setUserDetails({
          ...userDetails,
          first_name: firstName,
          last_name: lastName,
          location,
          profession,
          bio,
        });
      } else {
        toast({
          title: 'Error',
          description: data.error || 'Failed to update profile.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast({
        title: 'Error',
        description: 'Unable to update profile.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <UserSettingsLayout>
      <Box width="100%" bg="white" px={{ base: 5, md: 10 }} py={8}>
        <Box mb={8} maxW="720px">
          <Text fontSize="xl" fontWeight="700" color="brand.700">Public Profile</Text>
          <Text fontSize="sm" color="gray.900" mt={1}>Update your name, location, and bio.</Text>
        </Box>
        <VStack align="flex-start" width="100%" maxW="720px">
          <VStack spacing={4} align="stretch" width={{ base: "100%", md: "50%" }}>
            <Input
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              variant="filled"
              bg="gray.50"
            />
            <Input
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              variant="filled"
              bg="gray.50"
            />
            <Input
              placeholder="Location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              variant="filled"
              bg="gray.50"
            />
            <Input
              placeholder="Profession"
              value={profession}
              onChange={(e) => setProfession(e.target.value)}
              variant="filled"
              bg="gray.50"
            />
            <Input
              placeholder="Bio"
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              variant="filled"
              bg="gray.50"
            />
            <Button 
              //colorScheme="blue" 
              onClick={handleSave}
              alignSelf="flex-start" 
              width="auto"
            >
              Save Changes
            </Button>
          </VStack>
        </VStack>
      </Box>
    </UserSettingsLayout>
  );
};

export default Profile;
